export enum ROUTE {
  Index = "/",

  /* Auth */
  Login = "/login",

  // Volley's own login, for admins, coaches and reception. Kept stable for
  // when /login sends members to kltk.se instead.
  VolleyLogin = "/volley-login",

  ForceChangePassword = "/force-change-password",

  PasswordChange = "/password-change",

  /* Users */
  Users = "/medlemmar",

  /* Memberships */
  Memberships = "/medlemskap",

  /* Tracks */
  Tracks = "/banor",

  /* Bookings */
  Bookings = "/bokningar",
  Activities = "/aktiviteter",
  /* Settings */
  Admin = "/admins",
  Integrations = "/integrationer",
  Settings = "/installningar",
  EmailTemplates = "/installningar/email-mallar",

  /* My Profile */
  MyProfile = "/min-profil",

  /* Coach */
  Coach = "/tranare",
  /* Admin operating one coach's own schedule view */
  CoachSchedule = "/tranare/:coachId",

  /* Facility */
  Facility = "/hallen",

  /* Opening Times */
  OpeningTimes = "/oppettider",

  /* Reset Password */
  ResetPassword = "/reset-password",

  /* Visual Art Preview */
  VisualArtPreview = "/visual-art-preview",

  /* Statistic */
  Statistics = "/statistik",
}

export enum ROUTE_LABEL {
  Index = "Hem",

  /* Auth */
  Login = "Logga in",

  /* Users */
  Users = "Medlemmar",

  /* Memberships */
  Memberships = "Medlemskap",

  /* Tracks */
  Tracks = "Banornas priser",

  /* Bookings */
  Bookings = "Bokningar",
  Activities = "Aktiviteter",
  /* Settings */
  Admin = "Admins",
  Integrations = "Integrationer",
  Settings = "Inställningar",
  EmailTemplates = "E-postmallar",
  /* My Profile */
  MyProfile = "Profil",

  /* Coach */
  Coach = "Tränare",

  /* Facility */
  Facility = "Öppettider",

  /* Opening Times */
  OpeningTimes = "Öppettider",

  /* Statistic */
  Statistics = "Statistik",
}

export enum Weekday {
  Monday = 0,
  Tuesday = 1,
  Wednesday = 2,
  Thursday = 3,
  Friday = 4,
  Saturday = 5,
  Sunday = 6,
}

export enum CourtTypeEnum {
  INDOOR,
  OUTDOOR,
}

export enum BookingEnum {
  IDLE = "IDLE",
  CONTRACT = "CONTRACT",
  DROP_IN = "DROP_IN",
}

export enum StatusEnum {
  CANCELLED = "CANCELLED",
  PENDING = "PENDING",
  CONFIRMED = "CONFIRMED",
  NO_SHOW = "NO_SHOW",
  SEMI_NO_SHOW = "SEMI_NO_SHOW",
  COMPLETED = "COMPLETED",
  CHECKED_IN = "CHECKED_IN",
  PAID = "PAID",
  PAID_NOT_CHECKED_IN = "PAID_NOT_CHECKED_IN",
  PAID_NO_SHOW = "PAID_NO_SHOW",
  // Guest slot paid for before the actual guest has been chosen.
  PAID_NOT_CHOSEN = "PAID_NOT_CHOSEN",
}

/**
 * A booking still belongs to the member unless it was cancelled or is
 * mid-creation. Checking in and paying both rewrite the status
 * (CHECKED_IN, PAID, PAID_CHECKED_IN, PAID_NOT_CHECKED_IN…), so testing for
 * CONFIRMED alone makes a booking look like someone else's the moment the
 * desk touches it. Mirrors is_active_booking in the bookings lambda.
 */
export const INACTIVE_BOOKING_STATUSES: string[] = [
  StatusEnum.CANCELLED,
  StatusEnum.PENDING,
];

export const isActiveBookingStatus = (status?: string): boolean =>
  !!status && !INACTIVE_BOOKING_STATUSES.includes(status);

export enum CourtEnum {
  CC = "CC",
  B1 = "B1",
  B2 = "B2",
  B3 = "B3",
  B4 = "B4",
  B5 = "B5",
  B6 = "B6",
  B7 = "B7",
  B8 = "B8",
  B9 = "B9",
  B10 = "B10",
  B11 = "B11",
  B12 = "B12",
  B14 = "B14",
  B15 = "B15",
}
export enum CourtId {}
//  5008  Cc

//  4918  Bana 1

//  5007  Bana 2

//  4934  Bana 3

//  4919  Bana 4

//  4935  Bana 5

//  4936  Bana 6

//  5318  Bana 7

//  5316  Bana 8

//  5317  Bana 9

//  5300  Bana 10

//  5301  Bana 11

//  5302  Bana 12

//  5304  Bana 14

//  5305  Bana 15

export enum TitleEnum {
  // Hedersledamot = "Hedersledamot",
  // Elitnål = "Elitnål",
  Sponsor = "Sponsor",
  Personal = "Personal",
}

export enum StatisticsParticipantRoleEnum {
  BOOKER = "BOOKER",
  CO_PLAYER = "CO_PLAYER",
  GUEST = "GUEST",
  ACTIVITY = "ACTIVITY",
}

export enum StatisticsLeadTimeEnum {
  SAME_DAY_09 = "SAME_DAY_09",
  SAME_DAY_23 = "SAME_DAY_23",
  DAY_1_09 = "DAY_1_09",
  DAY_2_09 = "DAY_2_09",
  DAY_3_09 = "DAY_3_09",
  DAY_4_09 = "DAY_4_09",
  DAY_5_PLUS_09 = "DAY_5_PLUS_09",
}

export enum OccupancyAggregationType {
  MEMBER_TYPE = "MEMBER_TYPE",
  GUEST = "GUEST",
  COURT = "COURT",
}

export enum NoShowReportStatusEnum {
  RESOLVED = "RESOLVED",
  ACTIVE = "ACTIVE",
  REMOVED = "REMOVED",
}
